import api from './client';
import type { ProcessTasksResponse } from './types';

export const schedulerApi = {
  /**
   * Process all due scheduled tasks
   * Note: This endpoint should typically only be called by GCP Cloud Scheduler,
   * not directly from the frontend.
   */
  processTasks: async (): Promise<ProcessTasksResponse> => {
    const { data } = await api.post('/scheduler/process-tasks');
    return data;
  },
};
